import { Component, OnInit, Input, NgModule, ViewEncapsulation, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { InfoB, InfoBoxType } from '@app/models/infobox';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FeatureSettingsStoreService } from '@app/services/feature-settings-store.service';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { SortablejsModule } from 'ngx-sortablejs';
import { NgSubscribeModule } from '@app/directives/ng-subscribe.directive';
import { InfoBoxUtilities } from '@app/components/infobox-zone/infobox-utility';
import { TextInfoboxModule } from '@app/components/infobox-zone/text/text.component';
import { PictureInfoboxModule } from '@app/components/infobox-zone/picture/picture.component';
import { VideoInfoboxModule } from '@app/components/infobox-zone/video/video.component';

@Component({
  selector: 'app-infobox',
  templateUrl: './infobox.component.html',
  styleUrls: ['./infobox.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InfoboxComponent implements OnInit {

  _box: InfoB;

  @Input() set box(value) {
    this._box = value;
    this.cdr.markForCheck();
  }

  @Input() isAreaHero: boolean;
  @Input() textAlignmentClass: string;
  featureSettings = this.featureSettingsStoreService.state;

  constructor(
    private featureSettingsStoreService: FeatureSettingsStoreService, private cdr: ChangeDetectorRef) {
  }

  ngOnInit(): void {

  }

  getOverlayClass(box: InfoB) {
    let linkClass = '';
    if (box.LinkUrl || box.VideoEmbedCode) {
      linkClass = 'hover-text-infobox';
    }
    if (box.Type === InfoBoxType.Picture || box.Type === InfoBoxType.Video) {
      const overlayClass = this.featureSettings.disableOverlayOnInfoBoxes ? 'gradient-overlay-only-hover' : 'gradient-overlay';
      const hoverClass = overlayClass + ' ' + linkClass;
      return hoverClass;
    } else {
      return linkClass;
    }
  }

  getStyleClasses(box: InfoB) {
    return `${InfoBoxUtilities.getStyleClasses(box)} ${this.textAlignmentClass ? this.textAlignmentClass : 'justify-content-center'}`;
  }

  getCustomStyle(box: InfoB) {
    return InfoBoxUtilities.getCustomStyle(box);
  }

}
@NgModule({
  declarations: [InfoboxComponent],
  exports: [InfoboxComponent],
  imports: [
    CommonModule,
    TextInfoboxModule,
    PictureInfoboxModule,
    VideoInfoboxModule,
    MatSlideToggleModule,
    MatButtonModule,
    RouterModule,
    MatMenuModule,
    SortablejsModule,
    NgSubscribeModule
  ]
})
export class InfoboxModule { }
